import { FC, ReactNode } from 'react';
import { FlexBox, Skeleton } from '@brg/ui';
import { ProjectCardContainer, ProjectCardWrapper, ProjectCardWrapperDouble } from './styles';
import imgDef from '../../assets/project.svg';
import { useLocation } from 'react-router-dom';

export interface ProjectCardLayoutProps {
    isLoading?: boolean;
    grants?: ReactNode;
    title?: ReactNode;
    author?: ReactNode;
    likes?: ReactNode;
    img?: string;
    identifier?: string;
    onClick?: (identifier: string, e?: any) => void;
    isMoreVisible?: boolean;
    more?: ReactNode;
    href?: string;
    width?: string;
    height?: string;
    rank?: number;
    metaAlwaysVisible?: boolean;
    onMouseEnter?: any;
}

export const ProjectCardLayout: FC<ProjectCardLayoutProps> = (props) => {
    const {
        isLoading,
        isMoreVisible,
        grants,
        title,
        author,
        likes,
        img,
        identifier,
        more,
        width,
        height,
        onClick,
        onMouseEnter
    } = props;
    const location = useLocation();

    return (
        <>
            {!location.search.includes('display=doublegrid') && (
                <ProjectCardContainer width={width} height={height} img={img ?? imgDef} isLoading={true}>
                    <ProjectCardWrapper
                        width={width}
                        height={height}
                        onClick={(e) => {
                            onClick?.(identifier ?? '', e);
                        }}
                        onMouseEnter={onMouseEnter}
                        isLoading={isLoading}
                        img={img ?? imgDef}
                    >
                        <FlexBox className={'meta'} width={'100%'} justify={'flex-start'}>
                            {isLoading || !isMoreVisible ? null : more}
                        </FlexBox>
                        <FlexBox className={'meta'} direction={'column'} directionMobile={'column'} width={'100%'}>
                            <FlexBox width={'100%'} className={'pcw'} height={32} offsetBottom={8} gx={20}>
                                {isLoading && <Skeleton width={32} height={32} />}
                                {isLoading && <Skeleton width={32} height={32} />}
                                {!isLoading ? grants : null}
                            </FlexBox>
                            <FlexBox width={'100%'} offsetBottom={5}>
                                {isLoading ? <Skeleton height={32} width={'100%'} /> : title}
                            </FlexBox>
                            <FlexBox align={'flex-end'} width={'100%'} justify={'space-between'}>
                                <div onClick={(event) => event.stopPropagation()}>
                                    {isLoading ? <Skeleton height={20} width={100} /> : author}
                                </div>
                                <div> {isLoading ? <Skeleton height={20} width={25} /> : likes}</div>
                            </FlexBox>
                        </FlexBox>
                    </ProjectCardWrapper>
                </ProjectCardContainer>
            )}
            {location.search.includes('display=doublegrid') && (
                <ProjectCardContainer img={img ?? imgDef} width={width} height={height} isLoading={true}>
                    <ProjectCardWrapperDouble
                        onClick={() => {
                            onClick?.(identifier ?? '');
                        }}
                        isLoading={isLoading}
                        img={img ?? imgDef}
                    >
                        <FlexBox className={'meta'} width={'100%'} justify={'flex-start'}>
                            {isLoading || !isMoreVisible ? null : more}
                        </FlexBox>
                        <FlexBox className={'meta'} direction={'column'} directionMobile={'column'} width={'100%'}>
                            <FlexBox width={'100%'} className={'pcw'} height={32} offsetBottom={8} gx={20}>
                                {isLoading && <Skeleton width={32} height={32} />}
                                {isLoading && <Skeleton width={32} height={32} />}
                                {!isLoading ? grants : null}
                            </FlexBox>
                            <FlexBox width={'100%'} offsetBottom={5}>
                                {isLoading ? <Skeleton height={32} width={'100%'} /> : title}
                            </FlexBox>
                            <FlexBox align={'flex-end'} width={'100%'} justify={'space-between'}>
                                <div onClick={(event) => event.stopPropagation()}>
                                    {isLoading ? <Skeleton height={20} width={100} /> : author}
                                </div>
                                <div> {isLoading ? <Skeleton height={20} width={25} /> : likes}</div>
                            </FlexBox>
                        </FlexBox>
                    </ProjectCardWrapperDouble>
                </ProjectCardContainer>
            )}
        </>
    );
};
import { FC, ReactNode } from 'react';
import { FlexBox, Skeleton } from '@brg/ui';
import { ProjectCardContainer, ProjectCardWrapper, ProjectCardWrapperDouble } from './styles';
import imgDef from '../../assets/project.svg';
import { useLocation } from 'react-router-dom';

export interface ProjectCardLayoutProps {
    isLoading?: boolean;
    grants?: ReactNode;
    title?: ReactNode;
    author?: ReactNode;
    likes?: ReactNode;
    img?: string;
    identifier?: string;
    onClick?: (identifier: string, e?: any) => void;
    isMoreVisible?: boolean;
    more?: ReactNode;
    href?: string;
    width?: string;
    height?: string;
    rank?: number;
    metaAlwaysVisible?: boolean;
    onMouseEnter?: any;
}

export const ProjectCardLayout: FC<ProjectCardLayoutProps> = (props) => {
    const {
        isLoading,
        isMoreVisible,
        grants,
        title,
        author,
        likes,
        img,
        identifier,
        more,
        width,
        height,
        onClick,
        onMouseEnter
    } = props;
    const location = useLocation();

    return (
        <>
            {!location.search.includes('display=doublegrid') && (
                <ProjectCardContainer width={width} height={height} img={img ?? imgDef} isLoading={true}>
                    <ProjectCardWrapper
                        width={width}
                        height={height}
                        onClick={(e) => {
                            onClick?.(identifier ?? '', e);
                        }}
                        onMouseEnter={onMouseEnter}
                        isLoading={isLoading}
                        img={img ?? imgDef}
                    >
                        <FlexBox className={'meta'} width={'100%'} justify={'flex-start'}>
                            {isLoading || !isMoreVisible ? null : more}
                        </FlexBox>
                        <FlexBox className={'meta'} direction={'column'} directionMobile={'column'} width={'100%'}>
                            <FlexBox width={'100%'} className={'pcw'} height={32} offsetBottom={8} gx={20}>
                                {isLoading && <Skeleton width={32} height={32} />}
                                {isLoading && <Skeleton width={32} height={32} />}
                                {!isLoading ? grants : null}
                            </FlexBox>
                            <FlexBox width={'100%'} offsetBottom={5}>
                                {isLoading ? <Skeleton height={32} width={'100%'} /> : title}
                            </FlexBox>
                            <FlexBox align={'flex-end'} width={'100%'} justify={'space-between'}>
                                <div onClick={(event) => event.stopPropagation()}>
                                    {isLoading ? <Skeleton height={20} width={100} /> : author}
                                </div>
                                <div> {isLoading ? <Skeleton height={20} width={25} /> : likes}</div>
                            </FlexBox>
                        </FlexBox>
                    </ProjectCardWrapper>
                </ProjectCardContainer>
            )}
            {location.search.includes('display=doublegrid') && (
                <ProjectCardContainer img={img ?? imgDef} width={width} height={height} isLoading={true}>
                    <ProjectCardWrapperDouble
                        onClick={() => {
                            onClick?.(identifier ?? '');
                        }}
                        isLoading={isLoading}
                        img={img ?? imgDef}
                    >
                        <FlexBox className={'meta'} width={'100%'} justify={'flex-start'}>
                            {isLoading || !isMoreVisible ? null : more}
                        </FlexBox>
                        <FlexBox className={'meta'} direction={'column'} directionMobile={'column'} width={'100%'}>
                            <FlexBox width={'100%'} className={'pcw'} height={32} offsetBottom={8} gx={20}>
                                {isLoading && <Skeleton width={32} height={32} />}
                                {isLoading && <Skeleton width={32} height={32} />}
                                {!isLoading ? grants : null}
                            </FlexBox>
                            <FlexBox width={'100%'} offsetBottom={5}>
                                {isLoading ? <Skeleton height={32} width={'100%'} /> : title}
                            </FlexBox>
                            <FlexBox align={'flex-end'} width={'100%'} justify={'space-between'}>
                                <div onClick={(event) => event.stopPropagation()}>
                                    {isLoading ? <Skeleton height={20} width={100} /> : author}
                                </div>
                                <div> {isLoading ? <Skeleton height={20} width={25} /> : likes}</div>
                            </FlexBox>
                        </FlexBox>
                    </ProjectCardWrapperDouble>
                </ProjectCardContainer>
            )}
        </>
    );
};
